import apiService from '@/helpers/apiService'
import { hasAuthorities } from '@/utils/authorities'
import * as types from './types'

export default {
  headers({
    session: {
      model: { access }
    }
  }) {
    return {
      Authorization: (access && `Bearer ${access}`) || null
    }
  },

  isAuthenticationKeysExists({ session }) {
    return !!session.model.access || !!session.model.refresh
  },

  isProfileLoaded({ session }) {
    return session.model.user && !!session.model.user.email
  },

  isDirectLoginExist({ session }) {
    return !!session.model.user.directLogin
  },

  isLocalPromptExist({ session }) {
    return !!session.prompt
  },

  accountCPL(state) {
    return state[types.SESSION].model.user.accountAvgCpls
  },

  // TODO: избавиться от этого флага (вместо этого использовать authorities)
  isViewSession({ session }) {
    return session.model.currentlyViewProfile !== null
  },

  hasAuthorities({ session }) {
    return authorities => hasAuthorities(authorities, session.model.authorities)
  },

  dateRangeArray({ dictionary }) {
    return i18n => dictionary.dateRangeArray.map(range => ({
      name: i18n.t(range.key),
      value: range.value
    }))
  },

  adGroupTypes({ dictionary }) {
    return i18n => dictionary.adGroupTypes.map(type => ({
      name: i18n.t(type.key),
      value: type.value
    }))
  },

  blacklistLevelsOptions({ dictionary, campaigns }) {
    return (i18n) => {
      const levels = dictionary.blacklistLevels.map(level => ({
        type: level.type,
        value: level.value,
        name: i18n.t(level.key)
      }))
      const campaignItems = campaigns.list.map(item => ({
        type: 'campaign',
        value: item.id,
        name: item.name
      }))
      return levels.concat(campaignItems)
    }
  },

  notificationEmails(state) {
    const { emailList } = state[types.ACCOUNT_SETTINGS].model
    if (!emailList) return []
    return emailList
  },

  apiService() {
    return apiService
  }
}
